import {
  Box,
  Button,
  Card,
  Divider,
  FormControl,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  Radio,
  TextField,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material';
import React, { useEffect } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useTranslation } from 'react-i18next';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import { useSelector } from 'react-redux';

const SchedulersList = ({
  gridSize,
  setCurrentScheduler,
  currentScheduler,
  setCurrentEditingScheduler,
  setOpenScreensDrawer,
}) => {
  const { t } = useTranslation();
  const isDarkTheme = useTheme().palette.mode === 'dark';
  const { user } = useSelector((state) => state.User);

  const [searchPhrase, setSearchPhrase] = React.useState('');

  const { schedulers } = useSelector((state) => state.Scheduler);

  const handleSearch = () => {};

  useEffect(() => {
    setCurrentScheduler(schedulers[0]?._id);
  }, []);

  const ScheduleElement = ({ name, color, id }) => {
    const handleSelect = () => setCurrentScheduler(id);
    return (
      <>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            p: 1,
            px: 2,
            justifyContent: 'space-between',
            borderBottom: '1px solid #2d3748',
            cursor: 'pointer',
            transition: 'background-color 0.15s ease',
            '&:hover': {
              backgroundColor: isDarkTheme ? '#1f2937' : '#f2f4f7',
            },
          }}
          key={id}
          onClick={handleSelect}
        >
          <Box>
            <Tooltip title={name.length > 40 ? name : ''}>
              <Typography component='label' htmlFor={id}>
                {name.length > 40 ? `${name.slice(0, 40)}...` : name}
              </Typography>
            </Tooltip>
            <IconButton
              onClick={() =>
                setCurrentEditingScheduler({
                  open: true,
                  data: {
                    id: id,
                    name: name,
                    color: color,
                  },
                })
              }
            >
              <EditIcon fontSize='small' />
            </IconButton>
          </Box>

          <Box>
            <Tooltip title={'Add this scheduler to a screen'}>
              {/* <IconButton onClick={() => setOpenScreensDrawer(true)}>
                                <AddIcon />
                            </IconButton> */}
              <Button
                size='small'
                variant='outlined'
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenScreensDrawer(true);
                }}
              >
                Add to screen
              </Button>
            </Tooltip>

            <Radio
              checked={currentScheduler == id ? true : false}
              onChange={() => setCurrentScheduler(id)}
              value={name}
              name='scheduleSelect'
              id={id}
              sx={{
                color: color,
                '&.Mui-checked': {
                  color: color,
                },
              }}
            />
          </Box>
        </Box>
      </>
    );
  };

  return (
    <Grid xs={gridSize} item>
      <Card
        sx={{
          display: 'flex',
          flexDirection: 'column',
          position: 'fixed',
          width: '22%',
        }}
        variant='outlined'
      >
        <Typography variant='h6' textAlign={'center'} sx={{ p: 2 }}>
          {t('views.scheduler.schedulersList')}
        </Typography>
        <Divider />
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-end',
            p: 2,
            backgroundColor: isDarkTheme ? '#1C2536' : '#F8F9FA',
          }}
        >
          <TextField
            sx={{
              width: '90%',
            }}
            label={t('views.scheduler.search')}
            variant='standard'
            value={searchPhrase}
            onInput={(e) => setSearchPhrase(e.target.value)}
          />
          <IconButton
            onClick={handleSearch}
            sx={{
              width: '10%',
            }}
          >
            <SearchIcon />
          </IconButton>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            maxHeight: "460px",
            overflowY: "scroll"
          }}
        >
          {schedulers.map((scheduler) => {
            return (
              <ScheduleElement
                key={scheduler._id}
                name={scheduler.name}
                color={scheduler.color}
                id={scheduler._id}
              />
            );
          })}
          <Tooltip
            title={
              schedulers.length <
              Number(
                user.plan.planFeatures.find((f) => f.slug == 'max_schedulers')
                  ?.value
              )
                ? ''
                : t('views.scheduler.maxSchedulersErr').replace(
                    '{{max}}',
                    user.plan.planFeatures.find(
                      (f) => f.slug == 'max_schedulers'
                    )?.value
                  )
            }
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Button
                disabled={
                  schedulers.length <
                  Number(
                    user.plan.planFeatures.find(
                      (f) => f.slug == 'max_schedulers'
                    )?.value
                  )
                    ? false
                    : true
                }
                startIcon={<AddIcon />}
                onClick={() =>
                  setCurrentEditingScheduler({
                    open: true,
                    data: {
                      name: '',
                      color: '',
                    },
                  })
                }
              >
                {t('views.scheduler.addPreset')}
              </Button>
            </Box>
          </Tooltip>
        </Box>
      </Card>
    </Grid>
  );
};

export default SchedulersList;
